import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import {
  confirmUserAcount,
  userDefinitionsApiError,
} from "../../store/actions";
import { Link, withRouter } from "react-router-dom";
import {
  ErrorModal,
  MessageBoxModal,
} from "../../components/Common/CombinedComponents";

class ConfirmUserAcount extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      messageBoxModal: false,
      token: "",
    };

  }

  componentDidMount() {
    this.props.apiError("");
    const { onConfimUserAcount } = this.props;
    const search = window.location.search;
    const params = new URLSearchParams(search);
    const confirmToken = params.get("token");

    onConfimUserAcount(confirmToken);
    this.setState({ messageBoxModal: true });
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { error } = this.props;
    if (prevProps.error !== error) {
      this.setState({ error: error });
    }
  }

  onLoginLinkClick = e => { 
    e.preventDefault();
    this.setState({ messageBoxModal: false });
    this.props.history.push("/login");
  };

  render() {
    const { error, messageBoxModal } = this.state;

    return (
      <React.Fragment>
        <MessageBoxModal
          messageText={this.props.t("yourActivationHasBeenSuccessfullyCompleted")}
          messageDetailText={
            this.props.t("youCanApplyByLoggingInWithYourEmailAddress")
          }
          show={messageBoxModal}
          onCloseClick={this.onLoginLinkClick}
        />
        {/*    {error && (
          <ErrorModal
            errorMessage={error}
            onCloseModalClick={() => this.setState({ error: undefined })}
          />
        )} */}
      </React.Fragment>
    );
  }
}

ConfirmUserAcount.propTypes = {
  onConfimUserAcount: PropTypes.func,
  className: PropTypes.any,
  apiError: PropTypes.any,
  error: PropTypes.any,
  history: PropTypes.any,
  t: PropTypes.any,
  token: PropTypes.any
};

const mapStateToProps = ({ UserDefinition }) => ({
  error: UserDefinition.error,
});

const mapDispatchToProps = dispatch => ({
  onConfimUserAcount: token => dispatch(confirmUserAcount(token)),
  apiError: error => dispatch(userDefinitionsApiError(error)),
});
 
export default withRouter(
  withTranslation()(
    connect(mapStateToProps, mapDispatchToProps)(ConfirmUserAcount)
  )
);